import { InfoIcon } from 'components/icons/Info'
import { useTranslationTyped } from 'i18n/i18n'
import { observer } from 'mobx-react-lite'

export const NewVersionBannerContents = observer(function NewVersionBanner({
  onClickLater,
  onClickRefresh,
}: {
  onClickLater: () => void
  onClickRefresh: () => void
}) {
  const { tt } = useTranslationTyped()

  return (
    <div className="absolute top-0 left-0 z-100 flex w-full flex-row items-center gap-4 border-b-1 bg-surface p-3">
      <InfoIcon size={28} />
      <strong className="mr-2 text-body-large">
        {tt.banners.new_app_version_popup()}
      </strong>
      <div className="grow" />
      <button
        className="rounded-md p-1.5 text-label-large hover:bg-surface-dim"
        onClick={onClickLater}
      >
        {}
        {tt.banners.do_later()}
      </button>
      <button
        className="rounded-md p-1.5 text-label-large hover:bg-surface-dim"
        onClick={onClickRefresh}
      >
        {}
        {tt.banners.new_app_version_popup_refresh()}
      </button>
    </div>
  )
})
